const ShowDetails = (props) => {
    return (
        <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-xs-12 no-padding show-date"><span>{props.date}</span></div>
            <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 no-padding show-location">
                <div>
                    <span className="show-location-title">{props.venue}</span><br/>
                    {props.location}<br/>
                    {props.time}
                </div>
            </div>
            { (props.link !== "#" && props.link !== "" && props.link !== null) ? (
                <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 no-padding show-ticket"><a href={props.link} target="_blank" rel="noreferrer" className="button secondary">Website <i className="fa-solid fa-up-right-from-square button-trailing-icon"></i></a></div>
            ) : null } 
        </div>
    );
};

export default ShowDetails;